import { Category, Settings } from '../api/types';
import { daysInCurrentMonth } from './horizons';

/**
 * Дневной бюджет (только повседневные категории, is_daily=1):
 *   - если в Настройках есть override (число) — берём его;
 *   - иначе сумма plan_month по повседневным Расход-категориям / дней в текущем месяце.
 * Нерегулярные траты (терапия, подарки, аренда…) в дневной лимит не входят —
 * один большой чек не должен ломать день и стрик.
 */
export function computeDailyBudget(
  categories: Category[],
  settings: Settings | null,
  now: Date = new Date(),
): number {
  if (settings && settings.daily_budget_override != null && settings.daily_budget_override > 0) {
    return settings.daily_budget_override;
  }
  const monthlyPlan = categories
    .filter((c) => c.type === 'Расход' && c.is_daily)
    .reduce((s, c) => s + (c.plan_month || 0), 0);
  return monthlyPlan / daysInCurrentMonth(now);
}

/** Повседневная ли операция: по категории; неизвестная категория считается повседневной. */
export function isDailyExpense(
  categoryName: string,
  catByName: Map<string, Category>,
  fallbackType: string,
): boolean {
  const cat = catByName.get(categoryName);
  if (cat) return cat.type === 'Расход' && !!cat.is_daily;
  return fallbackType === 'Расход';
}
